module.exports = __webpack_public_path__ + "static/Clock-Free.d407163e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Clock-Free.svg
// module id = 1449
// module chunks = 168707334958949